import {
  CapacityGranularity,
  capacityGranularity,
} from "./capacityGranularity";
import { Id, id } from "./id";

type CapacityAdjustmentRequest = {
  resourceId: Id;
  from: string;
  to: string;
  granularity: CapacityGranularity;
  value: number;
};

const capacityAdjustmentRequest: CapacityAdjustmentRequest = {
  resourceId: id,
  from: "",
  to: "",
  granularity: capacityGranularity,
  value: 0,
};

export type { CapacityAdjustmentRequest };

export { capacityAdjustmentRequest };
